import React from 'react';
import {Box, Typography, Link, useTheme, useMediaQuery} from '@mui/material';

const Footer: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            sx={{
                backgroundColor: '#f5f5f5',
                padding: '0.5rem 1rem',
                marginTop: 'auto',
                mt:2,
                position: 'relative',
                textAlign: 'center',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography
                variant="body2"
                color="textSecondary"
                sx={{mb: isMobile ? '0.25rem' : 0, width: '100%'}}
            >
                &copy; {new Date().getFullYear()} Slapský pohár Fun – App
            </Typography>

            <Link
                href="https://forms.gle/bFe4CyYafnD7UaqAA"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                    position: isMobile ? 'static' : 'absolute',
                    right: isMobile ? 'auto' : '1rem',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile ? 'none' : 'translateY(-50%)',
                    color: 'gray',
                    fontSize: '0.875rem',
                    mt: isMobile ? '0.25rem' : 0,
                    textAlign: 'center',
                }}
            >
                Hlášení chyb a návrh vylepšení
            </Link>
        </Box>
    );
};

export default Footer;
